"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

function loadExternalScripts(externalScripts, onComplete, baseAddress) {
  return __awaiter(this, void 0, void 0, function () {
    var hasError, promises, ex_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          hasError = false;
          if (!(externalScripts && externalScripts.length > 0)) return [3
          /*break*/
          , 4];
          promises = externalScripts.map(function (externalScript) {
            return loadScript(externalScript, baseAddress);
          });
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , Promise.all(promises)];

        case 2:
          _a.sent();

          return [3
          /*break*/
          , 4];

        case 3:
          ex_1 = _a.sent();
          console.log({
            ex: ex_1
          });
          hasError = true;
          return [3
          /*break*/
          , 4];

        case 4:
          if (!hasError) {
            if (onComplete) {
              onComplete();
            }
          }

          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.loadExternalScripts = loadExternalScripts;

function loadScript(script, baseAddress) {
  return __awaiter(this, void 0, void 0, function () {
    var src, options, preventBaseAddressPrefix, workingBaseAddress, workingSrc, scriptStoreKey, scriptsLoaded, _i, _a, documentScript;

    var _this = this;

    return __generator(this, function (_b) {
      src = typeof script === 'string' ? script : script.src;
      options = (typeof script === 'string' ? {} : script.options) || {};
      preventBaseAddressPrefix = typeof script === 'object' && script.preventBaseAddressPrefix || false;

      if (src && baseAddress && !src.startsWith('http://') && !src.startsWith('https://') && !preventBaseAddressPrefix) {
        workingBaseAddress = baseAddress.endsWith('/') ? baseAddress.substr(0, baseAddress.length - 1) : baseAddress;
        workingSrc = src.startsWith('/') ? src.substr(1) : src;
        src = [workingBaseAddress, workingSrc].join('/');
      }

      scriptStoreKey = 'ksys-loadScript-store';

      if (window && !window[scriptStoreKey]) {
        window[scriptStoreKey] = {};
      }

      scriptsLoaded = window && window[scriptStoreKey] || {};

      for (_i = 0, _a = Array.from(document.scripts); _i < _a.length; _i++) {
        documentScript = _a[_i];

        if (documentScript.dataset.source !== 'ksys') {
          scriptsLoaded[documentScript.src] = true;
        }
      }

      return [2
      /*return*/
      , new Promise(function (resolve, reject) {
        return __awaiter(_this, void 0, void 0, function () {
          var scriptElement, mustInsert, optionKeys, _i, optionKeys_1, key, currentScript;

          return __generator(this, function (_a) {
            scriptElement = Array.from(document.scripts).find(function (script) {
              return script.src === src;
            });

            if (scriptElement && scriptsLoaded[src]) {
              if (typeof script === 'object' && script.children && script.children.length > 0) {
                loadExternalScripts(script.children, function () {
                  resolve(scriptElement);
                }, baseAddress);
              } else {
                resolve(scriptElement);
              }
            } else {
              mustInsert = false;

              if (!scriptElement) {
                mustInsert = true;
                scriptElement = document.createElement('script');

                if (options) {
                  optionKeys = Object.keys(options);

                  if (optionKeys && optionKeys.length > 0) {
                    for (_i = 0, optionKeys_1 = optionKeys; _i < optionKeys_1.length; _i++) {
                      key = optionKeys_1[_i];
                      scriptElement[key] = options[key];
                    }
                  }
                } // Do this here to stop someone overriding these options


                scriptElement.dataset.source = 'ksys';
                scriptElement.type = 'text/javascript';
                scriptElement.src = src;
                scriptElement.crossOrigin = 'crossorigin';
              }

              if (scriptElement.addEventListener) {
                scriptElement.addEventListener('load', function () {
                  scriptsLoaded[src] = true;

                  if (typeof script === 'object' && script.children && script.children.length > 0) {
                    loadExternalScripts(script.children, function () {
                      resolve(scriptElement);
                    }, baseAddress);
                  } else {
                    resolve(scriptElement);
                  }
                }, false);
                scriptElement.addEventListener('error', function (error) {
                  delete scriptsLoaded[src];
                  reject("Could not load script: " + src);
                }, false);
              } else {
                reject('No addEventListener on scriptElement');
              }

              if (mustInsert) {
                currentScript = getCurrentScript();

                if (currentScript && currentScript.parentNode) {
                  currentScript.parentNode.insertBefore(scriptElement, currentScript);
                } else {
                  reject('Could not find document.currentScript or document.currentScript.parentNode');
                }
              }
            }

            return [2
            /*return*/
            ];
          });
        });
      })];
    });
  });
}

exports.loadScript = loadScript;

function getCurrentScript() {
  return document.currentScript || function () {
    var scripts = document.getElementsByTagName('script');
    return scripts[scripts.length - 1];
  }();
}